export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
  },

  methods: {
    answer(k) {
      return this.question.answers[k];
    },

    percentage(k) {
      return this.answer(k).percentage;
    },

    percentageStr(k) {
      return this.percentage(k).toFixed(1).toString();
    },
  },

  computed: {
    loop() {
      const loop = JSON.parse(JSON.stringify(this.question.question));
      loop['unsure'] = 'Not sure';
      loop['skipped'] = 'Skipped';

      return loop;
    },
  },
};
